import Settings from 'configs/Settings';

import Request from '@hotmart/request';

Request.register(`${Settings.api.clubUser}/v4/users/`, {
  get: {
    accounts: 'userInfo',
    avatar: 'avatar'
  }
});

Request.register(`${Settings.api.hotClub}/rest/v3`, {
  get: {
    'get.userAreaCode': '/userarea/code',
    'get.resultsByUserArea':
      '/quiz/resultsByUserArea?userAreaHash=:userAreaHash'
  }
});

Request.register(`${Settings.api.clubUser}/v4`, {
  get: {
    'get.user-name-by-comment-user-id': '/users/:commentUserId/name'
  }
});
